import type { DISPLAY_FIELD, ToDoListViewProps } from './types';
import { FlatListItem } from './components/FlatListItem';
import { FlatListBatchHeader } from './components/FlatListBatchHeader';
import { FlatViewSkeleton } from '../ProductionPlans/components/TasksDrawer/components/FlatViewSkeleton';
import type { TaskToDoEntry } from '@nexelem/graphne-api';
import { groupTasksByBatch } from './utils';

export type ToDoListProps = ToDoListViewProps<TaskToDoEntry[]> & {
  displayField: DISPLAY_FIELD;
  hasMoreToLoad: boolean;
};

export const ToDoListFlatView = ({
  displayField,
  tasksList,
  onCheck,
  onMoreClick,
  isCheckAllFilterChecked,
  lastElementRef: ref,
  hasMoreToLoad,
}: ToDoListProps) => {
  const groups = groupTasksByBatch(tasksList || []);
  const lastGroup = groups[groups.length - 1];

  return (
    <div className="flex grow flex-col overflow-x-hidden overflow-y-auto">
      {groups.map((group) => {
        if (group.kind === 'task') {
          return (
            <FlatListItem
              displayField={displayField}
              isCheckAllFilterChecked={isCheckAllFilterChecked}
              key={group.task.id}
              ref={group === lastGroup ? ref : undefined}
              task={group.task}
              onCheck={onCheck}
              onMoreClick={onMoreClick}
            />
          );
        }

        const lastTask = group.tasks[group.tasks.length - 1];

        return (
          <div className="todo-batch-group" key={`batch-${group.batchId}`}>
            <FlatListBatchHeader batchId={group.batchId} tasks={group.tasks} onCheck={onCheck} />
            {group.tasks.map((task) => (
              <FlatListItem
                isBatchChild
                displayField={displayField}
                isCheckAllFilterChecked={isCheckAllFilterChecked}
                key={task.id}
                ref={group === lastGroup && task === lastTask ? ref : undefined}
                task={task}
                onCheck={onCheck}
                onMoreClick={onMoreClick}
              />
            ))}
          </div>
        );
      })}
      {hasMoreToLoad && <FlatViewSkeleton rowsCount={3} />}
    </div>
  );
};
